import { useState } from 'react';

const testimonials = [
  { name: 'Margaret T.', location: 'Las Vegas, NV', text: 'Dr. Chen and her team have completely changed how I feel about going to the doctor. They actually listen and explain everything. I\'ve never felt more cared for in my life.', initials: 'MT' },
  { name: 'Carlos R.', location: 'Henderson, NV', text: 'Managing my diabetes used to feel overwhelming. AxisPoint gave me a real plan and checks in regularly. My A1C is the best it\'s been in years. Truly life-changing care.', initials: 'CR' },
  { name: 'Linda K.', location: 'Family of 4', text: 'We bring our whole family here — from our 6-year-old to my 72-year-old mother. One clinic, everyone covered. The staff is always warm and incredibly professional.', initials: 'LK' },
  { name: 'David M.', location: 'Summerlin, NV', text: 'I needed a same-day appointment for chest pain and they got me in within two hours. The thoroughness and follow-up care was exceptional. Truly outstanding.', initials: 'DM' },
  { name: 'Priya S.', location: 'North Las Vegas, NV', text: 'The telehealth option is a game changer for my busy schedule. Same quality care, no commute. I recommended AxisPoint to everyone in my office.', initials: 'PS' },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);
  const t = testimonials[active];

  return (
    <section className="py-28 bg-zinc-50 overflow-hidden">
      <div className="px-8 md:px-16 lg:px-24">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-16 gap-6">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-8 h-px bg-rose-500"></div>
              <span className="text-rose-500 text-xs font-semibold uppercase tracking-[0.25em]">Patient Stories</span>
            </div>
            <h2
              className="text-4xl md:text-6xl font-black text-zinc-900 leading-tight"
              style={{ fontFamily: "'Syne', sans-serif" }}
            >
              Real People,<br />Real Results
            </h2>
          </div>
          <div className="flex items-center gap-2">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setActive(i)}
                className={`transition-all duration-300 rounded-full cursor-pointer ${
                  i === active ? 'w-8 h-2 bg-rose-500' : 'w-2 h-2 bg-zinc-300 hover:bg-zinc-400'
                }`}
              />
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-8">
            <div
              className="text-zinc-200 font-black leading-none mb-6"
              style={{ fontFamily: "'Syne', sans-serif", fontSize: '8rem' }}
            >
              &ldquo;
            </div>
            <p
              className="text-2xl md:text-3xl text-zinc-800 font-medium leading-relaxed -mt-16 mb-10"
              style={{ fontFamily: "'Syne', sans-serif" }}
            >
              {t.text}
            </p>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-rose-500 text-white font-bold text-sm">
                {t.initials}
              </div>
              <div>
                <div className="text-zinc-900 font-bold text-sm">{t.name}</div>
                <div className="text-zinc-400 text-xs">{t.location}</div>
              </div>
              <div className="flex gap-0.5 ml-4">
                {[1,2,3,4,5].map(i => (
                  <i key={i} className="ri-star-fill text-rose-400 text-sm"></i>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-4 flex flex-col gap-3">
            {testimonials.map((item, i) => (
              <button
                key={item.name}
                onClick={() => setActive(i)}
                className={`text-left p-4 rounded-2xl transition-all duration-200 cursor-pointer ${
                  i === active ? 'bg-zinc-900 text-white' : 'bg-white text-zinc-600 hover:bg-zinc-100'
                }`}
              >
                <div className="flex items-center gap-3">
                  <div className={`w-8 h-8 flex items-center justify-center rounded-full text-xs font-bold shrink-0 ${
                    i === active ? 'bg-rose-500 text-white' : 'bg-zinc-100 text-zinc-600'
                  }`}>
                    {item.initials}
                  </div>
                  <div>
                    <div className={`font-semibold text-sm ${i === active ? 'text-white' : 'text-zinc-800'}`}>{item.name}</div>
                    <div className="text-zinc-400 text-xs">{item.location}</div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
